import React, { useState } from "react";
import { Layout, Typography, Collapse, Button, Card, Input, Row, Col, message, Menu } from "antd";
import {
  FileDoneOutlined,
  FileExclamationOutlined,
  DownloadOutlined
} from "@ant-design/icons";

const { Header, Content, Sider } = Layout;
const { Title, Text } = Typography;
const { Panel } = Collapse;

const criteriaData = [
  {
    title: "Студенты и их достижения",
    indicators: [
      {
        name: "Призовые места на международных чемпионатах",
        files: ["ws_international_1.pdf"],
        value: "1 место - 2 студента"
      },
      {
        name: "Демоэкзамен Skills Passport",
        files: ["skills_demo_2025.pdf"],
        value: "35% прошли успешно"
      }
    ]
  },
  {
    title: "Кадровый состав",
    indicators: [
      {
        name: "Педагоги с международными сертификатами",
        files: ["teacher_certificates.pdf"],
        value: "10 из 100 педагогов"
      }
    ]
  }
];

const CollegeViewPage = () => {
  const [comment, setComment] = useState("");

  const handleAccept = () => {
    message.success("Данные колледжа приняты.");
  };

  const handleReject = () => {
    message.warning("Отправлено на доработку с комментарием: " + comment);
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider width={260} style={{ background: '#f5f5f5', padding: 16 }}>
        <Title level={5}>Критерии оценки</Title>
        <Menu mode="vertical" style={{ background: 'transparent' }}>
          {criteriaData.map((c, idx) => (
            <Menu.Item key={idx}>{c.title}</Menu.Item>
          ))}
        </Menu>
      </Sider>
      <Layout>
        <Header style={{ background: '#fff', padding: 16 }}>
          <Title level={4} style={{ margin: 0 }}>Колледж: Технический колледж Астана</Title>
        </Header>
        <Content style={{ padding: 32 }}>
          <Collapse accordion>
            {criteriaData.map((crit, index) => (
              <Panel header={crit.title} key={index}>
                {crit.indicators.map((ind, i) => (
                  <Card key={i} title={ind.name} style={{ marginBottom: 16 }}>
                    <p><Text strong>Данные:</Text> {ind.value}</p>
                    <p><Text strong>Документы:</Text></p>
                    {ind.files.map((file, j) => (
                      <Button key={j} icon={<DownloadOutlined />} type="link">{file}</Button>
                    ))}
                  </Card>
                ))}
              </Panel>
            ))}
          </Collapse>

          <Row gutter={[16, 16]} style={{ marginTop: 32 }}>
            <Col span={12}>
              <Input.TextArea 
                placeholder="Комментарий при отклонении"
                rows={4}
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              />
            </Col>
            <Col span={12} style={{ display: 'flex', justifyContent: 'end', gap: '12px' }}>
              <Button type="default" icon={<FileExclamationOutlined />} onClick={handleReject}>Отправить на доработку</Button>
              <Button type="primary" icon={<FileDoneOutlined />} onClick={handleAccept}>Принять</Button>
            </Col>
          </Row>
        </Content>
      </Layout>
    </Layout>
  );
};

export default CollegeViewPage;
